// ============================================================
// NETWORK CONFIGURATION — Toggle between mainnet and testnet here
// ============================================================

const NETWORKS = {
  mainnet: {
    chainId: '0xCC',           // 204
    chainIdDecimal: 204,
    chainName: 'opBNB',
    rpcUrls: ['https://opbnb-mainnet-rpc.bnbchain.org'],
    blockExplorerUrls: ['https://opbnbscan.com'],
    nativeCurrency: { name: 'BNB', symbol: 'BNB', decimals: 18 },
    usdt: '0x9e5aac1ba1a2e6aed6b32689dfcf62a509ca96f3',      // TODO: Replace with USDT address
    subgraphUrl: '',  // TODO: Replace with mainnet subgraph URL after deployment
    contracts: {
      core: '0x21c5D6501d146Fda9f4A6cD05932FFbaca4f7074',     // TODO: Replace with deployed address
      matrix: '0x24cb4D8818908ab0E13B9819aF42C4E944540B99',   // TODO: Replace with deployed address
      pools: '0xB48Df051B58385A051B511bA9f1e7E1E6dd74f49',    // TODO: Replace with deployed address
    },
  },
  testnet: {
    chainId: '0x15EB',         // 5611
    chainIdDecimal: 5611,
    chainName: 'opBNB',
    rpcUrls: ['https://opbnb-testnet-rpc.bnbchain.org'],
    blockExplorerUrls: ['https://testnet.opbnbscan.com'],
    nativeCurrency: { name: 'BNB', symbol: 'tBNB', decimals: 18 },
    usdt: '0xBf6596a279172D330b8b732D257Ee633B6FDA911',
    subgraphUrl: '',  // TODO: Replace with subgraph URL after deployment (e.g. https://api.goldsky.com/api/public/project_xxx/subgraphs/cluster/1.0.0/gn)
    contracts: {
      core: '0xc60eb63a3130Bf48F5D793750576f6b3d6a87d59',
      matrix: '0x785F2beF387D577C2c4518cC30948955ad29Be25',
      pools: '0xE5F6F96328E0aCc3955A8Eb14C3Fe819FCEB981C',
    },
  },
};

// ▼▼▼ CHANGE THIS TO SWITCH NETWORK ▼▼▼
const ACTIVE_NETWORK = 'mainnet';
// ▲▲▲ 'mainnet' or 'testnet' ▲▲▲

const config = NETWORKS[ACTIVE_NETWORK];

export default config;
export { ACTIVE_NETWORK };
